var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-avatar"},[(_vm.user.imageUrl)?_c('div',{staticClass:"user-avatar-image",style:('--avatar-size: ' + _vm.avatarSize + 'px')},[_c('img',{attrs:{"src":_vm.user.imageUrl}})]):_c('eg-avatar',{attrs:{"name":_vm.user.firstName + ' ' + _vm.user.lastName,"size":_vm.avatarSize}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }